<div class="d-flex">
  <div class="input-column flex-fill">
    <mat-select
            class="form-control"
            #monthNgModel="ngModel"
            [(ngModel)]="month"
            (ngModelChange)="monthChanged($event)"
            [ngClass]="{'is-invalid': !monthNgModel.valid || control.hasError('futureDate')}"
    >
      <mat-option *ngFor="let monthOption of monthOptions" [value]="monthOption.value">{{ monthOption.label }}</mat-option>
    </mat-select>
  </div>
  <div class="input-column flex-fill" *ngIf="showDay">
    <mat-select
            class="form-control"
            #dayNgModel="ngModel"
            [(ngModel)]="day"
            (ngModelChange)="dayChanged($event)"
            [ngClass]="{'is-invalid': !dayNgModel.valid || control.hasError('futureDate')}"
    >
      <mat-option *ngFor="let dayOption of (dayOptions$ | async)" [value]="dayOption.value">{{ dayOption.label }}</mat-option>
    </mat-select>
  </div>
  <div class="input-column flex-fill">
    <input
      class="form-control"
      #yearNgModel="ngModel"
      [(ngModel)]="year"
      [ngModelOptions]="{updateOn: 'blur'}"
      (ngModelChange)="yearChanged()"
      type="text"
      [ngClass]="{'is-invalid': !yearNgModel.valid || !control.valid}"
    />
    <div class="invalid-feedback" *ngIf="yearNgModel.hasError('min')">
      Must be at least {{ minYear }}
    </div>
    <div class="invalid-feedback" *ngIf="control.hasError('futureDate')">
      May not exceed the current date
    </div>
  </div>
</div>
